import {
  MEAL_PROGRAM_SELLING_PLAN_ID,
  CLEAN_BOUTIQUE_SELLING_PLAN_ID,
} from '@/constants/commerce'
import type { Cart, CartItem } from '@/types/shopify'

export const isSubscriptionLineItem = (line: CartItem) => {
  return !!line.sellingPlanAllocation?.sellingPlan
}

export const getSubscriptionType = (line: CartItem) => {
  if (!isSubscriptionLineItem(line)) return ''
  if (
    line.sellingPlanAllocation!.sellingPlan.id.endsWith(
      CLEAN_BOUTIQUE_SELLING_PLAN_ID.toString(),
    )
  )
    return 'monthly'
  if (
    line.sellingPlanAllocation!.sellingPlan.id.endsWith(
      MEAL_PROGRAM_SELLING_PLAN_ID.toString(),
    )
  )
    return 'weekly'
  return 'recurringly'
}

export const getCartAttributeByKey = (cart: Cart, key: string) => {
  return cart.attributes.find((attr) => attr.key === key)?.value
}

export const getLineItemAttributeByKey = (line: CartItem, key: string) => {
  return line.attributes.find((attr) => attr.key === key)?.value
}

export const replaceLineItemAttributeByKey = (
  line: CartItem,
  key: string,
  value: string,
) => {
  const attributes = [...line.attributes]
  const attrIndex = attributes.findIndex((attr) => attr.key === key)
  if (attrIndex === -1) return attributes
  attributes[attrIndex] = {
    key,
    value,
  }
  return attributes
}
